module.exports = __webpack_public_path__ + "static/media/soc-google.7016c540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/soc-google.svg
// module id = 787
// module chunks = 0